// BUILD-046 pass F1: where a floating dropdown or note is drawn against its anchor. Pure arithmetic over rectangles (tested in floatingPlacement.test.mjs); erasable TypeScript, no imports.
export interface AnchorRect {
  left: number;
  top: number;
  bottom: number;
  width: number;
}
export interface ViewportSize {
  width: number;
  height: number;
}
export interface FloatingPlacement {
  left: number;
  width: number;
  /** Set when the panel opens BELOW the anchor. */
  top: number;
  /** Set when the panel opens ABOVE the anchor (distance from the bottom of the window). */
  bottom: number;
  maxHeight: number;
  above: boolean;
}

const MARGIN = 8;
const GAP = 4;
/** Below this much room a panel flips above the anchor, when there is more room there. */
const ROOM_TO_STAY_BELOW = 160;

/**
 * Below the anchor when it fits (or when there is no better place), above it when the room below is too small and the room above is larger. Never wider than the window, never off its left or
 * right edge, never taller than the room on the side it opens to (at least 80 px, so it stays usable and scrolls inside itself).
 */
export function placeFloating(anchor: AnchorRect, viewport: ViewportSize, want: { height: number; minWidth: number }): FloatingPlacement {
  const width = Math.max(40, Math.min(Math.max(anchor.width, want.minWidth), viewport.width - 2 * MARGIN));
  const left = Math.max(MARGIN, Math.min(anchor.left, viewport.width - width - MARGIN));
  const below = viewport.height - anchor.bottom - MARGIN - GAP;
  const above = anchor.top - MARGIN - GAP;
  const flip = below < Math.min(want.height, ROOM_TO_STAY_BELOW) && above > below;
  const room = flip ? above : below;
  return {
    left,
    width,
    top: anchor.bottom + GAP,
    bottom: viewport.height - anchor.top + GAP,
    maxHeight: Math.max(80, Math.min(want.height, room)),
    above: flip,
  };
}
